import { BaseVue } from '../base';
import Vue from "vue";

new Vue({
    el: '#app',
    mixins: [BaseVue],
    data() {
        let pageState = window.__PAGE_STATE__;

        return {
            slide: 0,
            sliding: null,
            productId: pageState.productId || null,
            productProfileId: pageState.productProfileId || null,
            productName: pageState.productName || null,
            productImage: pageState.productImage || null,
            productPrice: pageState.productPrice || null,
            productQty: pageState.productQty || null,
            productColors: pageState.productColors || [],
            productSizes: pageState.productSizes || [],
        }
    },
    created() {
        if (this.productColors.length) {
            const firstItem = this.productColors[0];
            this.selectedColor = {
                id: firstItem.id,
                code: firstItem.code,
                price: firstItem.price,
                qty: firstItem.quantity,
            }
        }
        if (this.productSizes.length) {
            const firstItem = this.productSizes[0];
            this.selectedSize = {
                id: firstItem.id,
                code: firstItem.code,
                price: firstItem.price,
                qty: firstItem.quantity,
            }
        }
    },
    methods: {
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
    },
});
